export default __webpack_public_path__ + "0b31ccd4e59893baadc3054ff737d09b.webp";